declare const window: any;
export const sendEvent = (
  componentName: string,
  eventName: string,
  label?: string,
  value?: string
) => {
  process.env.NODE_ENV === 'development' &&
    console.log('send event: ', componentName, eventName, label, value);

  // Send event to Google Analytics
  window.gtag('event', componentName, {
    event_category: eventName,
    event_label: label,
    value: value,
  });

  // Send event to Clarity
  window.clarity('set', eventName, componentName, label, value);
};
